import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import MainMenu from './Components/MainMenu';
import Page from './Components/Page';
import './Docs.css';

class Docs extends Component{
  constructor(){
    super();
    this.state = {
      pages: [
        { path: 'assessment-answer', title: 'Assessment Answer' },
        { path: 'breadcrumb', title: 'Breadcrumb' },
        { path: 'button', title: 'Button' },
        { path: 'callout', title: 'Callout' },
        { path: 'calendar', title: 'Calendar' },
        { path: 'card', title: 'Card' },
        { path: 'card-row', title: 'Card Row' },
        { path: 'checkbox', title: 'Checkbox' },
        { path: 'custom-field-list', title: 'Custom Field List' },
        { path: 'dashboard-link', title: 'Dashboard Link' },
        { path: 'dropdown', title: 'Dropdown' },
        { path: 'field', title: 'Field'},
        { path: 'file-upload', title: 'File Upload' },
        { path: 'form-panel', title: 'Form Panel' },
        { path: 'heading-button', title: 'Heading with Button' },
        { path: 'icon-button', title: 'Icon Button' },
        { path: 'image', title: 'Image' },
        { path: 'image-cropper', title: 'Image Cropper' },
        { path: 'input', title: 'Input' },
        { path: 'list-item', title: 'List' },
        { path: 'pagination', title: 'Pagination' },
        { path: 'panels', title: 'Panels' },
        { path: 'progress-bar', title: 'Progress Bar' },
        { path: 'radio', title: 'Radio' },
        { path: 'selectable-images', title: 'Selectable Images' },
        { path: 'sockets', title: 'Sockets' },
        { path: 'stamp', title: 'Stamp' },
        { path: 'schedule', title: 'Schedule'},
        { path: 'structure', title: 'Structure' },
        { path: 'structure-item', title: 'Structure Item' },
        { path: 'table', title: 'Table' },
        { path: 'tabs', title: 'Tabs' },
        { path: 'two-col-selector', title: 'Two Column Selector' },
        { path: 'typography', title: 'Typography' }
      ]
    }
  }

  render(){
    return(
      <Router>
        <div>

          <div className="docs-layout">

            <div className="docs-layout__sidebar">
              <MainMenu pages={this.state.pages} />
            </div>

            <Route exact path="/" component={() => (
              <Page title="Home" path="index"/>
            )} />

            {this.state.pages.map((page, i ) =>
              <Route key={i} path={`/${page.path}`} component={() => (
                <Page title={page.title} path={page.path} />
              )} />
            )}

          </div>

        </div>
      </Router>
    );
  }
}

export default Docs;


// WEBPACK FOOTER //
// ./src/Docs.js